/**
 * @flow
 * @relayHash 7e73bed00f6e70b77ecd6f691ac447e5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Experiences_QueryVariables = {|
  page: string
|};
export type Experiences_QueryResponse = {|
  +bootcamps: ?$ReadOnlyArray<?{|
    +id: ?string,
    +name: string,
    +src: string,
    +srcMain: ?string,
    +caption: ?string,
  |}>
|};
*/


/*
query Experiences_Query(
  $page: String!
) {
  bootcamps(pagePath: $page) {
    id
    name
    src
    srcMain
    caption
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "bootcamps",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pagePath",
        "variableName": "page",
        "type": "String"
      }
    ],
    "concreteType": "Bootcamp",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "src",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "srcMain",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "caption",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Experiences_Query",
  "id": null,
  "text": "query Experiences_Query(\n  $page: String!\n) {\n  bootcamps(pagePath: $page) {\n    id\n    name\n    src\n    srcMain\n    caption\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Experiences_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Experiences_Query",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'af7f1d73ca6201026318f0a1803f5f0c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/Pages/Experiences/__generated__/Experiences_Query.graphql.js